import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { fetchProviderData } from "../../../Apiservices/Auth/servers/fetchProviderData";
import { useFormik } from "formik";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import * as Yup from "yup";
import { useJsApiLoader } from "@react-google-maps/api";
import LOGO from "../../assets/thurent-logo.svg";
import "./Login.css";
import { serviceprovidersignup } from "../../../Apiservices/Auth/servers/serviceProviderSignUpServer";
import { handlePendingEvent, setCredentials } from "../../../store/authSlice";
import { homePagePath, passwordRegEx } from "../../../constant";
import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { setToken } from "../../../util/Cookies";
import { detectAndSaveUserCountry } from "../../../util/geoUtils";

function ThurentServiceProviderSignUp() {
  const phoneRegExp = /^[6-9]\d{9}$/;
  const [providerData, setProviderData] = useState([]);

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const [selectedCountry, setSelectedCountry] = useState('in');
  const [phoneValue, setPhoneValue] = useState('');
  const [showErrorDialogVisible, setShowErrorDialogVisible] = useState(false);
  const [errorDialogCont, setErrorDialogCont] = useState({});

  const dispatch = useDispatch();
  const authState = useSelector((state) => state);

  const { loading, error } = authState || {};

  const navigate = useNavigate();

  useEffect(() => {
    // Force location detection on page mount (no permission popup)
    const initLocation = async () => {
      const countryData = await detectAndSaveUserCountry();
      if (countryData && countryData.lowerIsoCode) {
        setSelectedCountry(countryData.lowerIsoCode);
        formik.setFieldValue('countryCode', countryData.countryCode);
      }
    };
    initLocation();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [provider_data] = await Promise.all([fetchProviderData()]);
        setProviderData(provider_data);
        console.log("provider_data", provider_data)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const showErrorDialog = (msg) => {
    setShowErrorDialogVisible(true);
    switch (msg) {
      case "User already exists.":
        setErrorDialogCont({
          content: "A user with this email or mobile number already exists.",
          btn: true,
        });
        break;
      default:
        setErrorDialogCont({ content: msg, btn: false });
    }
  };
  const [location, setLocation] = useState({ lat: 0, lng: 0 });
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_API_KEY || 'AIzaSyCfBZYkyctvp5zTzY-Rb1dfTYGW6TWSp7U';
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey,
    libraries: ["places", "maps"],  // Add required libs if needed
  });
  const fetchAddress = (lat, lng) => {
    if (!window.google || !window.google.maps) {
      console.error("Google Maps SDK not loaded");
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const result = results[0];
        const components = result.address_components;

        const getComponent = (types) =>
          components.find((comp) =>
            types.every((type) => comp.types.includes(type))
          )?.long_name || '';

        const addressObject = {
          formattedAddress: result.formatted_address,
          streetNumber: getComponent(['premise']) || getComponent(['street_number']),
          street:
            getComponent(['sublocality']) ||
            getComponent(['route']) ||
            getComponent(['neighborhood']),
          locality:
            getComponent(['locality']) || getComponent(['sublocality_level_1']),
          city:
            getComponent(['administrative_area_level_2']) || getComponent(['locality']),
          state: getComponent(['administrative_area_level_1']),
          country: getComponent(['country']),
          pincode: getComponent(['postal_code']),
          latitude: lat,
          longitude: lng,
        };

        console.log('Resolved Address:', addressObject);

        // ✅ Store full object in address
        formik.setFieldValue('address', addressObject);
      } else {
        console.error('Geocoding failed:', status);
        alert('Could not fetch address.');
      }
    });
  };



  const getcurrentlocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ lat: latitude, lng: longitude });
          console.log("latitude", latitude, "longitude", longitude)

          formik.setFieldValue('latitude', latitude);
          formik.setFieldValue('longitude', longitude);

          fetchAddress(latitude, longitude);
        },
        (error) => {
          console.error("Error fetching location:", error);
          alert("Unable to fetch location. Please enable location services.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  // Formik form handling
  const formik = useFormik({
    initialValues: {
      providerTypeIds: [],
      firstName: "",
      lastName: "",
      email: "",
      address: "",
      latitude: "",
      longitude: "",
      mobileNumber: "",
      password: "",
      countryCode: "",
    },
    validationSchema: Yup.object({
      providerTypeIds: Yup.array()
        .min(1, "You must select What service ypo provide")
        .required("Required"),
      firstName: Yup.string().required("First Name is required"),
      lastName: Yup.string().required("Last Name is required"),
      email: Yup.string().email("Invalid email address"),
      mobileNumber: Yup.string()
        .required("Mobile number is required")
        .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters long")
        .matches(
          passwordRegEx,
          "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character"
        )
        .required("Password is required"),
      address: Yup.object({
        formattedAddress: Yup.string().required("Address is required"),
        latitude: Yup.number().required("Latitude is required"),
        longitude: Yup.number().required("Longitude is required"),
      }).required("Address is required"),

    }),
    onSubmit: async (values) => {
      try {
        const data = await serviceprovidersignup(values);
        if (data.token) {
          setToken(data.token);
          dispatch(setCredentials(data));
          dispatch(handlePendingEvent());
          navigate("/service-provider/dashboard");
        }
      } catch (error) {
        showErrorDialog(error.message || "");
        console.log("Error: In Signup ");
        console.log(error);
      }
    },
  });
  return (
    <div className="th-auth">
      <Dialog
        className="th-auth__dialog"
        visible={showErrorDialogVisible}
        modal
        header={`Error`}
        footer={
          errorDialogCont.btn ? (
            <div>
              <Button
                size="small"
                label="Login"
                onClick={() => navigate("/service-provider/login")}
              />
              <Button
                size="small"
                label="Forgot Password"
                onClick={() => navigate("/service-provider/forgot-password")}
              />
            </div>
          ) : (
            <Button
              size="small"
              label="OK"
              onClick={() => setShowErrorDialogVisible(false)}
            />
          )
        }
        onHide={() => {
          if (!showErrorDialogVisible) return;
          setShowErrorDialogVisible(false);
        }}
      >
        <h4 style={{ fontWeight: "500" }}>{errorDialogCont.content}</h4>
      </Dialog>
      <div className="th-auth__container">
        <img
          src={LOGO}
          alt="thurent"
          className="th-auth__logo"
          onClick={() => {
            navigate(homePagePath);
          }}
        />
        <form onSubmit={formik.handleSubmit}>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: "5px",
            }}
          >
            <div className="mb-3">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                className="th-login__input"
              />
              {formik.touched.firstName && formik.errors.firstName && (
                <span className="error">{formik.errors.firstName}</span>
              )}
            </div>
            <div className="mb-3">
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                className="th-login__input"
              />
              {formik.touched.lastName && formik.errors.lastName && (
                <span className="error">{formik.errors.lastName}</span>
              )}
            </div>
          </div>

          <div className="mb-3">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formik.values.email}
              onChange={formik.handleChange}
              className="th-login__input"
            />
            {formik.touched.email && formik.errors.email && (
              <span className="error">{formik.errors.email}</span>
            )}
          </div>
          <div className="mb-3">
            <div style={{ position: "relative" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <input
                  type="text"
                  name="address"
                  placeholder="Address"
                  value={formik.values.address?.formattedAddress || ""}
                  onChange={formik.handleChange}
                  className="th-login__input"
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  onClick={getcurrentlocation}
                  style={{
                    padding: "8px 12px",
                    fontSize: "14px",
                    background: "#26b8e3",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    whiteSpace: "nowrap"
                  }}
                >
                  Use Location
                </button>
              </div>

            </div>
            {formik.touched.address && formik.errors.address && (
              <span className="error">{formik.errors.address}</span>
            )}
          </div>
          <div className="mb-3">
            {/* <input
              type="text"
              name="mobileNumber"
              maxLength="10"
              placeholder="Mobile Number"
              value={formik.values.mobileNumber}
              onChange={formik.handleChange}
              className="th-login__input"
            /> */}
            <PhoneInput
              country={selectedCountry}
              onlyCountries={['in', 'us']}
              disableCountryCode={true}
              disableDropdown={true}
              value={phoneValue}
              onChange={(value, data) => {
                // Store the full value (with dial code) in local state so PhoneInput
                // is correctly controlled and doesn't re-parse on re-render.
                setPhoneValue(value);

                const dialCode = data.dialCode;       // e.g., "91"
                const countryCode = `+${dialCode}`;   // "+91"

                // react-phone-input-2 with disableCountryCode={true} still prepends
                // the dial code internally to `value`. Strip it exactly once.
                const nationalNumber = value.startsWith(dialCode)
                  ? value.slice(dialCode.length)
                  : value;

                // Cap at 10 digits for the national number stored in formik
                const cleanedValue = nationalNumber.slice(0, 10);

                formik.setFieldValue('countryCode', countryCode);
                formik.setFieldValue('mobileNumber', cleanedValue);
                setSelectedCountry(data.countryCode);
              }}
              placeholder="Mobile Number"
              inputProps={{
                name: 'mobileNumber',
                required: true,
                onBlur: formik.handleBlur,
              }}
              containerClass="phone-container"
              inputClass="phone-input"
              buttonClass="phone-flag-button"
            />
            {formik.touched.mobileNumber && formik.errors.mobileNumber && (
              <span className="error">{formik.errors.mobileNumber}</span>
            )}
          </div>

          <div className="mb-3">
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formik.values.password}
                onChange={formik.handleChange}
                className="th-login__input"
              />
              <IconButton
                aria-label={
                  showPassword ? "hide the password" : "display the password"
                }
                onClick={handleClickShowPassword}
                edge="end"
                sx={{ position: "absolute", right: "12px", top: "-2px" }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </div>
            {formik.touched.password && formik.errors.password && (
              <span className="error">{formik.errors.password}</span>
            )}
          </div>

          <div className="mb-3">
            <fieldset className="th-login__input th-grey__text flex-column justify-content-start align-items-start">
              <legend>Select Provider Type(s)</legend>
              {providerData.length > 0 &&
                providerData.map((item) => {
                  const isSelected = formik.values.providerTypeIds.includes(item.id);
                  return (
                    <label key={item?.id}>
                      <input
                        name="providerTypeIds"
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => {
                          if (isSelected) {
                            // If already selected, remove it
                            formik.setFieldValue("providerTypeIds", []);
                          } else {
                            // Otherwise, select only this one
                            formik.setFieldValue("providerTypeIds", [item.id]);
                          }
                        }}
                        value={item?.id}
                      />
                      {item?.type}
                    </label>
                  );
                })}
            </fieldset>
            {formik.touched.providerTypeIds &&
              formik.errors.providerTypeIds && (
                <span className="error">{formik.errors.providerTypeIds}</span>
              )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="th-login__button font-inter"
          >
            <span className="Login-bitton"> {loading ? "SIGNING UP..." : "SIGNUP"}</span>
          </button>
          {error && <span className="error">Error: {error}</span>}
        </form>

        <button
          className="th-signup__button font-inter font-normal"
          onClick={() => navigate("/service-provider/login")}
        >
          Existing User? LOGIN
        </button>

        <div
          style={{
            fontSize: "12px",
            fontWeight: "500",
            color: "#888",
            marginTop: "15px",
            textAlign: "left",
          }}
        >
          By creating an account or logging in, you agree to Thurent’s{" "}
          <Link
            to="/privacy-policy"
            style={{ color: "#26b8e3", margin: "0 4px" }}
          >
            Privacy Policy.
          </Link>
        </div>

        <div className="flex w-full justify-content-center align-items-center mt-3">
          <Button
            label="Back to Home"
            icon="pi pi-home"
            className="th-backtohome__button"
            iconPos="right"
            severity="contrast"
            onClick={() => navigate(homePagePath)}
            size="small"
          />
        </div>
      </div>
    </div>
  );
}

export default ThurentServiceProviderSignUp;
